<script>
    export let status=false;
</script>

{#if status=='E'}
    <slot/>
{:else if status=='A'}
    <span class='text-danger'><slot/></span>
{:else if status=='C'}
    <span class='text-warning'><slot/></span>
{/if}